<DataGridView DataUrl="/Backend/Api/V2/Admin/Gruende/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="bezeichnung" header="Bezeichnung" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Gründe">
        <ng-template #staticContent>
          <GrundEdit [Key]="row?.key"></GrundEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Gründe">
        <ng-template #staticContent>
          <GrundEdit></GrundEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
